(() => {
	const namespaceKey = '__cntrAnnouncementBar';

	if (window[namespaceKey]) {
		window[namespaceKey].init(document);
		return;
	}

	const selector = '[data-cntr-announcement-bar]';
	const instances = new WeakMap();

	const getRoots = (scope) => {
		const roots = Array.from(scope.querySelectorAll(selector));

		if (scope instanceof Element && scope.matches(selector)) {
			roots.unshift(scope);
		}

		return roots;
	};

	const createInstance = (root) => {
		if (instances.has(root)) {
			return;
		}

		const slides = Array.from(root.querySelectorAll('[data-cntr-announcement-slide]'));
		const countdowns = Array.from(root.querySelectorAll('[data-cntr-countdown]'));
		const rotationInterval = Number.parseInt(root.dataset.rotationInterval, 10) || 4000;
		let currentIndex = Math.max(slides.findIndex((slide) => slide.classList.contains('is-active')), 0);
		let animationTimer;
		let rotationTimer;
		let countdownTimer;

		const updateCountdowns = () => {
			const now = Date.now();

			countdowns.forEach((countdown) => {
				const target = Date.parse(countdown.dataset.cntrCountdown || '');
				const difference = target - now;

				if (!Number.isFinite(target) || difference <= 0) {
					countdown.hidden = true;
					return;
				}

				const values = {
					days: Math.floor(difference / 86400000),
					hours: Math.floor((difference % 86400000) / 3600000),
					minutes: Math.floor((difference % 3600000) / 60000),
					seconds: Math.floor((difference % 60000) / 1000),
				};

				Object.entries(values).forEach(([unit, value]) => {
					const output = countdown.querySelector(`[data-cntr-countdown-unit="${unit}"]`);

					if (output) {
						output.textContent = String(value).padStart(2, '0');
					}
				});

				countdown.hidden = false;
			});
		};

		const updateBackground = (slide) => {
			const color = slide?.dataset.color;

			if (color) {
				root.style.setProperty('--cntr-announcement-background', color);
			}
		};

		const showSlide = (nextIndex) => {
			if (nextIndex === currentIndex || !slides[nextIndex]) {
				return;
			}

			const currentSlide = slides[currentIndex];
			const nextSlide = slides[nextIndex];

			window.clearTimeout(animationTimer);
			slides.forEach((slide) => slide.classList.remove('is-exiting', 'is-entering'));
			currentSlide.classList.remove('is-active');
			currentSlide.classList.add('is-exiting');
			nextSlide.classList.add('is-active', 'is-entering');
			currentIndex = nextIndex;
			updateBackground(nextSlide);

			animationTimer = window.setTimeout(() => {
				currentSlide.classList.remove('is-exiting');
				nextSlide.classList.remove('is-entering');
			}, 400);
		};

		const rotate = () => {
			showSlide((currentIndex + 1) % slides.length);
		};

		const followSlideLink = (slide) => {
			if (slide?.dataset.link) {
				window.location.assign(slide.dataset.link);
			}
		};

		const handleClick = (event) => {
			if (!(event.target instanceof Element) || event.target.closest('.cntr-announcement-bar__button')) {
				return;
			}

			followSlideLink(event.target.closest('[data-cntr-announcement-slide]'));
		};

		const handleKeydown = (event) => {
			if (event.key !== 'Enter' && event.key !== ' ') {
				return;
			}

			if (!(event.target instanceof Element) || !event.target.matches('[data-cntr-announcement-slide]')) {
				return;
			}

			event.preventDefault();
			followSlideLink(event.target);
		};

		root.addEventListener('click', handleClick);
		root.addEventListener('keydown', handleKeydown);
		updateBackground(slides[currentIndex]);
		updateCountdowns();

		if (slides.length > 1) {
			rotationTimer = window.setInterval(rotate, rotationInterval);
		}

		if (countdowns.length > 0) {
			countdownTimer = window.setInterval(updateCountdowns, 1000);
		}

		instances.set(root, () => {
			window.clearTimeout(animationTimer);
			window.clearInterval(rotationTimer);
			window.clearInterval(countdownTimer);
			root.removeEventListener('click', handleClick);
			root.removeEventListener('keydown', handleKeydown);
			instances.delete(root);
		});
	};

	const init = (scope = document) => {
		getRoots(scope).forEach(createInstance);
	};

	const destroy = (scope) => {
		getRoots(scope).forEach((root) => instances.get(root)?.());
	};

	window[namespaceKey] = { init, destroy };
	document.addEventListener('shopify:section:load', (event) => init(event.target));
	document.addEventListener('shopify:section:unload', (event) => destroy(event.target));
	init(document);
})();
